import { render, staticRenderFns } from "./DeliveryHistoryDetail.vue?vue&type=template&id=13cc004a&scoped=true"
import script from "./DeliveryHistoryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryHistoryDetail.vue?vue&type=style&index=0&id=13cc004a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc004a",
  null
  
)

export default component.exports